import { BuildClass, DateObj, DateTimeObj, TW_OVERFLOW_ELLIPSIS, } from '../../../../universal';
import { _, React } from '../../../lib';
import { AddButton } from '../buttons';
import { setContextMenu } from '../context-menu';
import { KebabMenu, KebabMenuToolbar } from '../kebab';
import { ListGrid } from '../list-grid';
import { CJSX } from '../meta-types';
import { TextSearched } from '../text';
import { SearchBox } from '../textbox';
import { Toolbar } from '../toolbar';
import { getMetaActions, getNoteActions } from './actions';
import { addNewNoteForm } from './add';
import { getFlattenedTags, TagIndicator } from './tags';
import { ACTION_CONTEXT_MENU_WIDTH, } from './types';
export const NoteList = (props) => {
    const rs = props.rs;
    const fmt = (obj, formatString) => DateTimeObj.parseISO(obj.Created).fmt(formatString);
    const flatTags = getFlattenedTags(rs);
    return (React.createElement(React.Fragment, null,
        React.createElement(Toolbar, { widthRHS: 120, lhs: React.createElement(React.Fragment, null,
                React.createElement(SearchBox, { className: "w-full", ref: rs.refs.searchBox, value: rs.state.searchText, onUpdate: v => {
                        rs.updateState({ searchText: v });
                        rs.props.state?.onUpdate?.({ searchText: v });
                    }, onArrowDelta: (delta, shiftKey) => {
                        const list = rs.refs.grid.current?.getList();
                        list?.moveSelection(delta, shiftKey);
                    } })), rhs: React.createElement(React.Fragment, null,
                React.createElement(CJSX, { cond: Boolean(rs.props.adding) },
                    React.createElement(AddButton, { lbl: "Add", onClick: () => {
                            addNewNoteForm(rs);
                        } })),
                React.createElement(KebabMenuToolbar, { preferLeft: true, width: 180, items: () => getMetaActions(rs) })) }),
        React.createElement(ListGrid, { multiple: true, value: rs.state.selectedNotes, onUpdate: x => {
                rs.updateState({ selectedNotes: x });
                rs.props.state?.onUpdate?.({ selectedNotes: x });
            }, data: rs.props.notes
                .filter(x => !x.Deleted || rs.state.showDeleted)
                .filter(x => !x.Archived || rs.state.showArchived)
                .filter(x => !rs.state.filteredTags ||
                _.some(rs.state.filteredTags, t => x.Tags.includes(t))), pk: x => x.ID, ref: rs.refs.grid, defaultSortingKey: "date", defaultSortingReverse: true, className: "!h-[calc(100%-40px)]", classRow: () => 'group', height: () => (rs.state.showCompactView ? 26 : 46), searchText: rs.state.searchText, fields: [
                {
                    key: 'date',
                    lbl: 'Date',
                    disabled: rs.state.showCompactView,
                    width: { init: 70 },
                    sortVal: x => x.Created,
                    text: x => fmt(x, 'dd/MM/yy ccc HH:mm | dd MMMM yyyy ccc hh:mm:ss a'),
                    tooltip: x => {
                        const date = fmt(x, 'cccc dd MMMM yyyy, h:mm:ss a');
                        const extraDeleted = x.Deleted
                            ? ' - note has been marked as deleted'
                            : '';
                        const extraArchived = x.Archived
                            ? ' - note has been archived'
                            : '';
                        return `${date}${extraDeleted}${extraArchived}`;
                    },
                    groupVal: x => DateTimeObj.parse(x.Created).date().fmt(),
                    groupName: k => DateObj.parse(String(k)).fmtDMY(),
                    filterVal: {
                        getKey: x => DateTimeObj.parse(x.Created).date().fmt(),
                        getText: k => DateObj.parse(String(k)).fmtDMY(),
                    },
                    display: x => (React.createElement("span", { className: BuildClass({
                            'group-hover:text-black': true,
                            'text-neutral-600': !x.Deleted,
                            'text-red-700': Boolean(x.Deleted),
                        }) },
                        React.createElement("div", null,
                            React.createElement(TextSearched, { text: fmt(x, 'dd/MM/yy'), needles: rs.state.searchText, tailwind: true })),
                        React.createElement("div", { className: "text-sm" },
                            React.createElement(TextSearched, { text: fmt(x, 'ccc HH:mm'), needles: rs.state.searchText, tailwind: true })))),
                },
                {
                    key: 'note',
                    lbl: 'Note',
                    className: () => BuildClass({
                        'p-0': rs.state.showCompactView,
                    }),
                    text: x => {
                        const parts = [
                            x.Title ?? '',
                            x.Meta?.text ?? '',
                            x.Note ?? '',
                            ...x.Tags.map(t => flatTags[t]?.DisplayName),
                        ];
                        return _.compact(parts).join(' ');
                    },
                    tooltip: x => x.Title ?? '',
                    display: x => rs.state.showCompactView ? (React.createElement(NotePreviewWidgetCompact, { rs: rs, note: x })) : (React.createElement(NotePreviewWidget, { rs: rs, note: x, flatTags: flatTags })),
                },
            ], onClick: () => {
                rs.refs.searchBox.current?.focus();
            }, onContextMenu: (x, e) => {
                e.preventDefault();
                let selected = rs.state.selectedNotes;
                if (!rs.state.selectedNotes.includes(x.ID)) {
                    rs.updateState({ selectedNotes: [x.ID] });
                    selected = [x.ID];
                }
                setContextMenu({
                    position: {
                        x: e.clientX,
                        y: e.clientY,
                    },
                    width: ACTION_CONTEXT_MENU_WIDTH,
                    items: () => getNoteActions(rs, selected
                        .map(id => rs.props.notes.find(n => n.ID == id))
                        .filter((n) => n != null)),
                });
            } })));
};
const NotePreviewWidgetCompact = (props) => {
    const rs = props.rs;
    const x = props.note;
    const attachment = getAttachmentInfo(x.Attachment);
    const textPreview = x.Note?.substring(0, 160).replaceAll('\n', ' ') ?? '';
    return (React.createElement("div", { className: "h-full relative" },
        React.createElement("div", { className: BuildClass({
                'text-black': Boolean(x.Title),
                'text-neutral-600': !x.Title,
                [TW_OVERFLOW_ELLIPSIS]: true,
            }) },
            React.createElement(TextSearched, { text: x.Title || textPreview, needles: rs.state.searchText, tailwind: true })),
        attachment && React.createElement(AttachmentIcon, { attachment: attachment })));
};
const NotePreviewWidget = (props) => {
    const rs = props.rs;
    const x = props.note;
    const attachment = getAttachmentInfo(x.Attachment);
    const archivedPrefix = x.Archived ? '[Archived]: ' : '';
    const textPreview = x.Note?.substring(0, 160).replaceAll('\n', ' ') ?? '';
    return (React.createElement("div", { className: "h-full relative whitespace-normal" },
        React.createElement("div", { className: "line-clamp-2" },
            React.createElement(CJSX, { cond: props.rs.state.showTagIndicators }, _.chain(x.Tags)
                .map(t => props.flatTags[t])
                .compact()
                .map(tag => React.createElement(TagIndicator, { tag: tag, includeText: false }))
                .value()),
            React.createElement("span", { className: "font-bold text-black inline" },
                React.createElement(TextSearched, { text: x.Title ?? '', needles: rs.state.searchText, tailwind: true })),
            x.Title && x.Note && (React.createElement("span", { className: "text-neutral-400 inline" }, " \u2022 ")),
            React.createElement("span", { className: "text-neutral-600 inline group-hover:text-black" },
                React.createElement(TextSearched, { text: `${archivedPrefix}${textPreview}`, needles: rs.state.searchText, tailwind: true }))),
        attachment && React.createElement(AttachmentIcon, { attachment: attachment }),
        React.createElement("div", { className: BuildClass([
                'absolute w-12 h-8 z-20',
                'top-[-3px] right-[-5px]',
                'opacity-0 group-hover:opacity-100',
                'transition-opacity duration-100',
            ]) },
            React.createElement("div", { className: BuildClass([
                    'w-full h-full text-right',
                    'bg-gradient-to-bl',
                    'from-[var(--row-bg)]',
                    'via-[var(--row-bg)]',
                    'to-transparent',
                ]) },
                React.createElement(KebabMenu, { className: {
                        div: [
                            'w-8 h-full rounded-md ml-auto',
                            'cursor-pointer hover:bg-[hsla(0,0%,0%,0.2)]',
                            'grid place-items-center',
                        ],
                        img: 'w-4 h-4',
                    }, preferLeft: true, width: ACTION_CONTEXT_MENU_WIDTH, items: () => getNoteActions(rs, [x]) })))));
};
const AttachmentIcon = (props) => {
    const attachment = props.attachment;
    return (React.createElement("div", { className: BuildClass([
            'absolute bottom-0 right-0',
            'w-8 h-5',
            'flex items-center justify-end',
            'pointer-events-none',
        ]), title: attachment?.title },
        React.createElement("div", { className: BuildClass([
                'absolute inset-0',
                'bg-gradient-to-l',
                'from-[var(--row-bg)]',
                'via-[var(--row-bg)]',
                'to-transparent',
            ]) }),
        React.createElement("img", { className: "w-4 h-4 mr-1 relative z-10", src: attachment?.icon, alt: attachment?.title })));
};
const getAttachmentInfo = (attachment) => {
    if (!attachment) {
        return null;
    }
    if (!attachment.MimeType || attachment.MimeType == 'application/pdf') {
        return {
            icon: '/static/img/i8/cute-pdf-icon.svg',
            title: 'PDF document attachment',
        };
    }
    if (attachment.MimeType.startsWith('image/')) {
        return {
            icon: '/static/img/i8/w11c-image.svg',
            title: 'Image attachment',
        };
    }
    return {
        icon: '/static/img/i8/color-note.svg',
        title: 'Attachment',
    };
};
//# sourceMappingURL=list.js.map